
import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faFilePdf, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";
import InvoiceModal from "./InvoiceModal";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import {
  canEdit,
  isAdminOrSuperAdmin,
  isOjcTask,
} from "../utils/permissions";

export default function Dashboard_job() {
  const { http, user } = AuthUser();
  const allowEdit = canEdit(user);
  const isJcAdmin = isAdminOrSuperAdmin(user);

  // OJC: admin/super admin only. K1/K2/others: everyone (incl. view-only).
  const canChangeTaskStatus = (task) => {
    if (isOjcTask(task)) return isJcAdmin;
    return true;
  };
  const [searchParams] = useSearchParams();
  const [tasks, setTasks] = useState([]);
  const [tasksind, setTasksInd] = useState([]);
  const [TaskCount, setTaskCount] = useState();
  const [TotalCount, setTotalCount] = useState();
  const [date, setDate] = useState(null);
  const [remark, setRemark] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [loginUserId, setloginUserId] = useState(user.id);
  const [selectedDepartmentId, setselectedDepartmentId] = useState(
    searchParams.get("department") || ""
  );
  const [selectedStatus, setsselectedStatus] = useState(
    searchParams.get("status") || "Pending"
  );
  const [selectedAssignedTo, setSelectedAssignedTo] = useState(
    searchParams.get("assigned_to") || ""
  );
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [editColumn, setEditColumn] = useState(null);
  const [users, setUsers] = useState([]);
  const [editUser, setEditUser] = useState({});
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceTaskId, setInvoiceTaskId] = useState(null);
  const [showSeatModal, setShowSeatModal] = useState(false);
  const [seatJcId, setSeatJcId] = useState(null);
  const [seatValue, setSeatValue] = useState("");
  const [seatLoading, setSeatLoading] = useState(false);

  useEffect(() => {
    const qAssigned = searchParams.get("assigned_to");
    const qStatus = searchParams.get("status");
    const qDept = searchParams.get("department");
    if (qAssigned != null) setSelectedAssignedTo(qAssigned);
    if (qStatus != null) setsselectedStatus(qStatus);
    if (qDept != null) setselectedDepartmentId(qDept);
  }, [searchParams]);

  useEffect(() => {
    http.get(`/department_user_company?&login_user=${user.id}`).then((res) => {
      setUsers(res.data.users);
    });
    fetchTaskDetails(selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate);
  }, [selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate]);

  const fetchTaskDetails = (
    seldepartment = "",
    selstatus = "",
    selassignedto = "",
    startDate = "",
    endDate = ""
  ) => {
    setIsLoading(true);
    let endpoint;
    if (user && user.department_id === 1) {
      endpoint = `/tasks_job?department=${seldepartment}&status=${selstatus}&assigned_to=${selassignedto}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}`;
    } else if (user) {
      endpoint = `/tasks_job?user=${user.id}&department=${seldepartment}&status=${selstatus}&assigned_to=${selassignedto}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}`;
    } else {
      setIsLoading(false);
      console.error("User is not defined or authenticated");
      return;
    }

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
          setTaskCount(res.data.data.length);
          setTotalCount(res.data.total_count);
        } else {
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get(`/branch`).then((res) => {
      setdepartments(res.data.users);
    });
  };
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);
  const openModal = async (taskId) => {
    setShowModal(true);
    await http
      .get(`/tasks_job_ind?id=${taskId}`)
      .then((res) => {
        setTasksInd(res.data.data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const handleChange = async (event) => {
    setselectedDepartmentId(event.target.value);
  };

  const handleChangeType = async (event) => {
    setsselectedStatus(event.target.value);
  };

  const handleChangeAssignedTo = async (event) => {
    setSelectedAssignedTo(event.target.value);
  };

  const handleChangeStartDate = async (event) => {
    setstartDate(event.target.value);
  };

  const handleChangeEndDate = async (event) => {
    setendDate(event.target.value);
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks_jc/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        // setTasks(response.data.data);
        fetchTaskDetails(selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate);
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const sendConfirm = async (userId, id) => {
    await http
      .post(`/send_confirm_jc/${userId}/${id}`)
      .then((response) => {
        toast.success("Confirmation Email/SMS sent");
        // setTasks(response.data.data);
        fetchTaskDetails(selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate);
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const resendOtp = async (taskId) => {
    await http
      .post(`/resend_otp`, { task_id: taskId })
      .then((response) => {
        if (response.data.success) {
          toast.success("OTP resent successfully to customer!");
          fetchTaskDetails(selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate);
        } else {
          toast.error(response.data.message || "Failed to resend OTP");
        }
      })
      .catch((err) => {
        console.error("Error resending OTP", err);
        const errorMessage = err.response?.data?.message || "Failed to resend OTP";
        toast.error(errorMessage);
      });
  };

  const handleSave = async (taskId) => {
    const task = tasks.find((t) => t.id === taskId);
    if (!canChangeTaskStatus(task)) {
      toast.error("Only admin or super admin can change OJC status");
      return;
    }
    if (currentStatus === null || taskId === null || currentStatus === "0") {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update_jc?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails(selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error(error.response?.data?.message || "Please select proper item");
    }
  };

  const openSeatModal = (jcId, currentValue) => {
    setSeatJcId(jcId);
    setSeatValue(currentValue === "yes" || currentValue === "no" ? currentValue : "");
    setShowSeatModal(true);
  };

  const closeSeatModal = () => {
    setShowSeatModal(false);
    setSeatJcId(null);
    setSeatValue("");
  };

  const handleSeatSubmit = async (e) => {
    e.preventDefault();
    if (!seatJcId) return;
    if (seatValue !== "yes" && seatValue !== "no") {
      toast.error("Please select Yes or No");
      return;
    }
    setSeatLoading(true);
    try {
      await http.put(`/jc_seat_submitted/${seatJcId}`, {
        jc_seat_submitted: seatValue,
      });
      toast.success("JC seat submitted updated");
      closeSeatModal();
      fetchTaskDetails(
        selectedDepartmentId,
        selectedStatus,
        selectedAssignedTo,
        startDate,
        endDate
      );
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
    } finally {
      setSeatLoading(false);
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData1({
      ...formData1,
      [e.target.name]: e.target.value,
    });
  };

  function getRandomLightColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  const backgroundColorMap = new Map();

  // Function to get a unique background color for a user.id
  function getUniqueBackgroundColor(userId) {
    if (!backgroundColorMap.has(userId)) {
      // If the user.id doesn't have a background color assigned, generate one and store it in the map
      backgroundColorMap.set(userId, getRandomLightColor());
    }
    return backgroundColorMap.get(userId);
  }

  const [formData1, setFormData1] = useState({
    assigned_to: "",
    assiger_branch: "",
    est_time: "",
    service_amount: "",
    description: "",
  });

  const openEditModal = async (taskAll, index) => {
    setEditColumn(index);
    setShowModal1(true);
    setFormData1({
      assigned_to: taskAll.assigned_to || "",
      assiger_branch: taskAll.assiger_branch || "",
      est_time: taskAll.est_time || "",
      service_amount: taskAll.service_amount || "",
      description: taskAll.description || "",
    });
    setEditUser(taskAll);
  };

  const saveEditedCustemer = async (e) => {
    e.preventDefault();
    try {
      if (!editUser) {
        // Handle the case when editUser is null
        console.error("No user data to edit.");
        return;
      }

      const response = await http.put(`/jc_edit/${editUser.id}`, formData1);
      if (response.data.data) {
        toast.success("Data updated successfully!");
        setShowModal1(false);
        fetchTaskDetails(selectedDepartmentId, selectedStatus, selectedAssignedTo, startDate, endDate);
      } else {
        console.log("API response is not an array");
      }
    } catch (error) {
      console.error("Error updating user", error);
      toast.error("An error occurred while updating the customer.");
    }
    setEditColumn("");
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModal1(false);
    setEditColumn("");
    setShowInvoiceModal(false);
  };

  const openInvoiceModal = (taskId) => {
    setInvoiceTaskId(taskId);
    setShowInvoiceModal(true);
  };

  const closeInvoiceModal = () => {
    setShowInvoiceModal(false);
    setInvoiceTaskId(null);
  };

  const calculateDaysDifference = (created_at) => {
    const createdDate = moment(created_at).startOf('day');
    const presentDate = moment().startOf('day');
    return presentDate.diff(createdDate, 'days');
};


console.log('tasks',tasks)

  const exportPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.setTextColor(13, 110, 253);
    doc.text("All Tasks List", 14, 15);
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(
      `Generated: ${moment().format("DD MMM YYYY, hh:mm A")}   |   Total Records: ${tasks.length}   |   Total Price: ${TotalCount ?? 0}`,
      14, 22
    );
    autoTable(doc, {
      startY: 27,
      head: [["No", "JC ID", "Created", "Days", "Branch", "Description", "Company", "Name", "Contact", "Status", "Del Date", "Est", "Price", "Assigned To"]],
      body: tasks.map((t, i) => [
        i + 1,
        `JC${t.id}`,
        moment(t.created_at).format("DD MMM,YY hh:mm A"),
        `${calculateDaysDifference(t.created_at)}D`,
        t.branch?.branch_name === "OTHER JC" ? `OJC-${t.job_card_number}` : (t.branch?.branch_name || "-"),
        t.description || "-",
        t.customer?.company || "-",
        t.customer?.name || "-",
        t.customer?.phone || "-",
        t.status || "-",
        t.target_date ? moment(t.target_date).format("DD MMM,YY") : "-",
        t.est_time ?? "-",
        t.service_amount ?? "-",
        t.assignee?.name ? `${t.assignee.name} ${t.assignee.last_name || ""}`.trim() : "-",
      ]),
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [13, 110, 253], textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      foot: [["", "", "", "", "", "", "", "", "", "", "", "Total", TotalCount ?? 0, ""]],
      footStyles: { fillColor: [220, 235, 255], fontStyle: "bold" },
    });
    doc.save(`tasks_list_${moment().format("YYYYMMDD_HHmm")}.pdf`);
  };

  const exportExcel = () => {
    const rows = tasks.map((t, i) => ({
      "No": i + 1,
      "JC ID": `JC${t.id}`,
      "Created": moment(t.created_at).format("DD MMM,YY hh:mm A"),
      "Days": `${calculateDaysDifference(t.created_at)}D`,
      "Branch": t.branch?.branch_name === "OTHER JC" ? `OJC-${t.job_card_number}` : (t.branch?.branch_name || "-"),
      "Description": t.description || "-",
      "Company": t.customer?.company || "-",
      "Name": t.customer?.name || "-",
      "Contact": t.customer?.phone || "-",
      "Status": t.status || "-",
      "Del Date": t.target_date ? moment(t.target_date).format("DD MMM,YY") : "-",
      "Est": t.est_time ?? "-",
      "Price": t.service_amount ?? "-",
      "Assigned To": t.assignee?.name ? `${t.assignee.name} ${t.assignee.last_name || ""}`.trim() : "-",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tasks");
    XLSX.writeFile(wb, `tasks_list_${moment().format("YYYYMMDD_HHmm")}.xlsx`);
  };

  return (
    <>
      <Toaster />

      {showModal && tasksind.length > 0 && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Product Details: <b>#JC {tasksind[0].id}</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group  mt-3">
                  <label>Product Name</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].product_name}
                  />
                </div>

                <div className="form-group  mt-3">
                  <label>Model</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].model}
                  />
                </div>

                <div className="form-group  mt-3">
                  <label>Others</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].brand}
                  />
                </div>

                <div className="form-group  mt-3">
                  <label>Engineer Remark</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].eng_remark}
                  />
                </div>

                <div className="form-group  mt-3">
                  <label>Damage Remark</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].damage_remark}
                  />
                </div>

                <div className="form-group  mt-3">
                  <label>Password</label>
                  <input
                    name="name"
                    className="form-control"
                    type="text"
                    value={tasksind[0].type}
                  />
                </div>

                <div className="form-group  mt-3">
               
                  <label>Power adapter:</label>
                  
                  {tasksind[0].power_adapter == 1 ? (
                    <b className="text-danger px-1">Yes</b>
                  ) : (
                    <b className="text-success px-1">No</b>
                  )}
                  <br />
                  <label>Carry case:</label>
                  
                  {tasksind[0].carry_case == 1 ? (
                    <b className="text-danger px-1">Yes</b>
                  ) : (
                    <b className="text-success px-1">No</b>
                  )}
                  <br />
                  <label>Laptop Bag:</label>
                 
                  {tasksind[0].laptop_bag == 1 ? (
                    <b className="text-danger px-1">Yes</b>
                  ) : (
                    <b className="text-success px-1">No</b>
                  )}
                  <br />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal1 && (
        <form onSubmit={saveEditedCustemer}>
          <div className="modal" tabindex="-1" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Job card</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group  mt-3">
                    <label>Assigned To</label>
                    <select
                      name="assigned_to"
                      className="form-control text-uppercase"
                      defaultValue={formData1.assigned_to}
                      onChange={handleChangeModal}
                      required
                    >
                      <option value="">Select a user</option>
                      {users.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.name} {user.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group  mt-3">
                    <select
                      defaultValue={formData1.assiger_branch}
                      onChange={handleChangeModal}
                      name="assiger_branch"
                      className="form-control mb-1"
                      required
                    >
                      <option value="">Select Branch</option>
                      {departments.map((dept, index) => (
                        <option key={index} value={dept.id}>
                          {dept.branch_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group  mt-2">
                    <label>Establish Time</label>
                    <select
                      name="est_time"
                      onChange={handleChangeModal}
                      className="form-control"
                      defaultValue={formData1.est_time}
                      required
                    >
                      <option value="0">0 Hour</option>
                      <option value="1">1 Hour</option>
                      <option value="2">2 Hour</option>
                      <option value="3">3 Hour</option>
                      <option value="4">4 Hour-Half day</option>
                      <option value="5">5 Hour</option>
                      <option value="6">6 Hour</option>
                      <option value="7">7 Hour</option>
                      <option value="8">8 Hour</option>
                    </select>
                  </div>

                  <div className="form-group  mt-2">
                    <label>Service Amount</label>
                    <input
                      name="service_amount"
                      onChange={handleChangeModal}
                      defaultValue={formData1.service_amount}
                      className="form-control"
                      type="number"
                    />
                  </div>

                  <div className="form-group  mt-2">
                    <label>Description</label>
                    <textarea
                      name="description"
                      onChange={handleChangeModal}
                      defaultValue={formData1.description}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      <div className="container mt-1">
        <div className="row mb-2">
          <div className="col-md-2">
            {user && user.department_id == 1 ? (
              <h1 className="mb-1">
                All Tasks List ({TaskCount}) Total Price
                <span className="text-primary">({TotalCount})</span>
              </h1>
            ) : (
              <h1 className="mb-1">Your Tasks List ({TaskCount}) </h1>
            )}
            <div className="d-flex gap-2 mt-1">
              <button
                className="btn btn-sm btn-danger"
                onClick={exportPDF}
                disabled={tasks.length === 0}
                title="Export PDF"
              >
                <FontAwesomeIcon icon={faFilePdf} className="me-1" /> PDF
              </button>
              <button
                className="btn btn-sm btn-success"
                onClick={exportExcel}
                disabled={tasks.length === 0}
                title="Export Excel"
              >
                <FontAwesomeIcon icon={faFileExcel} className="me-1" /> Excel
              </button>
            </div>
          </div>

          <div className="col-md-2 form-group text-end">
            <select
              onChange={handleChange}
              className="form-control mb-1"
              value={selectedDepartmentId}
            >
              <option value="">All Branch</option>
              {departments.map((dept, index) => (
                <option key={index} value={dept.id}>
                  {dept.branch_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2 form-group text-end">
            <select onChange={handleChangeType} className="form-control">
              <option value="">Select Status</option>
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Pend-Cus-Confir">Pend-Cus-Confir</option>
              <option value="Delivered">Delivered</option>
              <option value="Hold-In-HQ">Hold-In-HQ</option>
              <option value="Hold-To-HQ">Hold-To-HQ</option>
              <option value="Hold-waiting-RM"> Hold - waiting RM</option>
              <option value="Ready infomed">Ready infomed</option>
              <option value="Ready Return">Ready Return</option>
              <option value="Ready waiting po">Ready waiting po</option>
              <option value="Ready">Ready</option>
              <option value="Not_Taken">Not Taken</option>
              <td>
                {user.status === "Delivered" && (
                  <span className="badge bg-success font-size-13">
                    Delivered
                  </span>
                )}
                {user.status === "Pending" && (
                  <span className="badge bg-warning font-size-13">Pending</span>
                )}
                {user.status === "Hold-In-HQ" && (
                  <span className="badge bg-danger font-size-13">
                    Hold-In-HQ
                  </span>
                )}
                {user.status === "Hold-To-HQ" && (
                  <span className="badge bg-danger font-size-13">
                    Hold-To-HQ
                  </span>
                )}
                {user.status === "Hold-waiting-RM" && (
                  <span className="badge bg-warning font-size-13">
                    Hold - waiting RM
                  </span>
                )}
                {user.status === "Pend-Cus-Confir" && (
                  <span className="badge bg-danger font-size-13">
                    Pend-Cus-Confir
                  </span>
                )}
                {user.status === "Ready infomed" && (
                  <span className="badge bg-secondary font-size-13">
                    Ready infomed
                  </span>
                )}
                {user.status === "Ready waiting po" && (
                  <span className="badge bg-secondary font-size-13">
                    Ready Waiting PO
                  </span>
                )}
                {user.status === "Ready" && (
                  <span className="badge bg-success font-size-13">Ready</span>
                )}

                {user.status === "Not_Taken" && (
                  <span className="badge bg-secondary font-size-13">
                    Not Taken
                  </span>
                )}
                {user.status === "Ready Return" && (
                  <span className="badge bg-secondary font-size-13">
                    Ready Return
                  </span>
                )}
                {user.status === "Ready informed" && (
                  <span className="badge bg-secondary font-size-13">
                    Ready Informed
                  </span>
                )}
              </td>
            </select>
          </div>

          <div className="col-md-2 form-group text-end">
            <select onChange={handleChangeAssignedTo} className="form-control">
              <option value="">Select Assign To</option>
              <option value="">All Users</option>
              {users.map((user, index) => (
                <option key={index} value={user.id}>
                  {user.name} {user.last_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2 form-group text-end">
            <input
              name="start_date"
              onChange={handleChangeStartDate}
              class="form-control"
              type="date"
            ></input>
          </div>

          <div className="col-md-2 form-group text-end">
            <input
              name="end_date"
              onChange={handleChangeEndDate}
              class="form-control"
              type="date"
            ></input>
          </div>
        </div>

        <div className="branch-chip-bar mb-3">
          <span className="branch-chip-label">Branches</span>
          <button
            type="button"
            className={`branch-chip ${selectedDepartmentId === "" ? "active" : ""}`}
            onClick={() => setselectedDepartmentId("")}
          >
            All Branch
          </button>
          {departments.map((dept) => (
            <button
              type="button"
              key={dept.id}
              className={`branch-chip ${
                String(selectedDepartmentId) === String(dept.id) ? "active" : ""
              } ${
                dept.branch_name === "K1"
                  ? "chip-k1"
                  : dept.branch_name === "K2"
                  ? "chip-k2"
                  : dept.branch_name === "OTHER JC"
                  ? "chip-ojc"
                  : ""
              }`}
              onClick={() => setselectedDepartmentId(String(dept.id))}
            >
              {dept.branch_name}
            </button>
          ))}
        </div>

        <div className="table-responsive">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped table-center">
              <thead className="table-primary">
                <tr>
                  <th>No</th>
                  <th>ID</th>
                  <th className="text-danger">Created</th>
                  <th>DD</th>
                  <th>BR</th>
                  <th>Time</th>
                  <th>Description</th>
                  <th>Company</th>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>Status</th>
                  <th>JC Seat</th>
                  <th>Del Date</th>
                  <th>Est</th>
                  <th>Price</th>
                  <th>ATo</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((user, index) => (
                  <tr key={index} className="table-row">
                    <td>{index + 1}</td>
                    <td>JC{user.id}</td>
                    <td className="created-date">
                      <div className="date-line">{moment(user.created_at).format("DD MMM,YY")}</div>
                      <div className="time-line">{moment(user.created_at).format("hh:mm A")}</div>
                    </td>
                    <td>{calculateDaysDifference(user.created_at)}D</td>
                    <td>
                      <b
                        className={
                          user.branch?.branch_name == "K1"
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        {user.branch?.branch_name === "OTHER JC" ? "OJC-"+user.job_card_number : user.branch?.branch_name}
                      </b>
                    </td>
                    <td className="time-status-column">
                      {user.assiger_branch == 4 && (
                        <div className="time-status-wrapper">
                          {user.start_otp_validated == 1 && (
                            <div className="time-status-item start-time">
                              <i className="fas fa-check-circle"></i>
                              {moment(user.start_otp_validated_time).format("hh:mm A")}
                            </div>
                          )}
                          {user.end_otp_validated == 1 && (
                            <div className="time-status-item end-time">
                              <i className="fas fa-flag-checkered"></i>
                              {moment(user.end_otp_validated_time).format("hh:mm A")}
                            </div>
                          )}
                          {(!user.start_otp_validated && !user.end_otp_validated) && (
                            <div className="time-status-item pending">
                              <i className="fas fa-clock"></i>
                              Pending
                            </div>
                          )}
                        </div>
                      )}
                    </td>
                    <td
                      width="17%"
                      className="custom-tooltip font_desc"
                      title={user.description}
                      
                    >
                      {user.description}
                    </td>
                    <td>
                      <td className="text-uppercase fw-bold">
                        {user.customer?.company}
                      </td>
                    </td>
                    <td>
                      <td className="text-uppercase fw-bold">
                        {user.customer?.name}
                      </td>
                    </td>
                    <td>
                      <td className="text-uppercase fw-bold">
                        {user.customer?.phone}
                      </td>
                    </td>
                    <td>
                      {user.status === "Delivered" && (
                        <span className="badge bg-success font-size-13">
                          Delivered
                        </span>
                      )}
                      {user.status === "Pending" && (
                        <span className="badge bg-warning font-size-13">
                          Pending
                        </span>
                      )}
                      {user.status === "Hold-In-HQ" && (
                        <span className="badge bg-danger font-size-13">
                          Hold-In-HQ
                        </span>
                      )}
                      {user.status === "Hold-To-HQ" && (
                        <span className="badge bg-danger font-size-13">
                          Hold-To-HQ
                        </span>
                      )}
                      {user.status === "Hold-waiting-RM" && (
                        <span className="badge bg-warning font-size-13">
                          Hold - waiting RM
                        </span>
                      )}
                      {user.status === "Pend-Cus-Confir" && (
                        <span className="badge bg-danger font-size-13">
                          Pend-Cus-Confir
                        </span>
                      )}
                      {user.status === "Ready infomed" && (
                        <span className="badge bg-secondary font-size-13">
                          Ready infomed
                        </span>
                      )}
                      {user.status === "Ready waiting po" && (
                        <span className="badge bg-secondary font-size-13">
                          Ready Waiting PO
                        </span>
                      )}
                      {user.status === "Ready Return" && (
                        <span className="badge bg-secondary font-size-13">
                          Ready Return
                        </span>
                      )}

                      {user.status === "Ready" && (
                        <span className="badge bg-success font-size-13">
                          Ready
                        </span>
                      )}

                      {user.status === "Not_Taken" && (
                        <span className="badge bg-secondary font-size-13">
                          Not Taken
                        </span>
                      )}
                      {user.status === "Ready informed" && (
                        <span className="badge bg-secondary font-size-13">
                          Ready Informed
                        </span>
                      )}
                    </td>
                    <td className="text-center">
                      {user.jc_seat_submitted === "yes" ? (
                        <span className="badge bg-success">Yes</span>
                      ) : user.jc_seat_submitted === "no" ? (
                        <span className="badge bg-danger">No</span>
                      ) : (
                        <span className="badge bg-secondary">—</span>
                      )}
                    </td>
                    <td width="7%">
                      {moment(user.target_date).format("DD MMM,YY")}{" "}
                    </td>
                    <td >{user.est_time} </td>
                    <td>{user.service_amount}</td>
                    <td
                      className={`text-uppercase fw-bold ${
                        user.assignee?.name && user.assignee?.last_name
                          ? "background-color-class"
                          : ""
                      }`}
                      style={{
                        color: getUniqueBackgroundColor(user.assignee?.id),
                      }}
                    >
                      {user.assignee?.name} 
                    </td>

                    <td width="160px" className="action-column">
                      <div className="action-row-1">
                        <div className="status-group">
                          {canChangeTaskStatus(user) ? (
                            <>
                              <select
                                onChange={statusUpdate}
                                className="form-select-sm custom_select"
                              >
                                <option value="0">Select</option>
                                <option value="Pending">Pending</option>
                                <option value="Pend-Cus-Confir">Pend-Cus-Confir</option>
                                <option value="Delivered">Delivered</option>
                                <option value="Hold-In-HQ">Hold-In-HQ</option>
                                <option value="Hold-To-HQ">Hold-To-HQ</option>
                                <option value="Hold-waiting-RM">Hold - waiting RM</option>
                                <option value="Ready infomed">Ready infomed</option>
                                <option value="Ready Return">Ready Return</option>
                                <option value="Ready">Ready</option>
                                <option value="Not_Taken">Not Taken</option>
                                <option value="Ready waiting po">Ready waiting po</option>
                              </select>
                              <button
                                className="save-btn"
                                onClick={() => handleSave(user.id)}
                                title="Save Status"
                              >
                                ✓
                              </button>
                            </>
                          ) : (
                            <span
                              className="badge bg-secondary"
                              title="Only admin / super admin can change OJC status"
                            >
                              Admin only
                            </span>
                          )}
                          <Link
                            to={`/jobcart/print/${user.id}`}
                            className="action-btn"
                            title="Print"
                          >
                            🖨️
                          </Link>
                          <button
                            className="action-btn invoice-btn"
                            onClick={() => openInvoiceModal(user.id)}
                            title="Download Invoice"
                          >
                            📄
                          </button>
                        </div>
                      </div>

                      <div className="action-row-2">
                        <div className="action-buttons">

                          <button
                            className="action-btn"
                            onClick={() => openModal(user.id)}
                            title="View More"
                          >
                            VM
                          </button>

                          {loginUser === 1 && allowEdit && (
                            <button
                              className="action-btn text-danger"
                              onClick={() => {
                                if (window.confirm("Are you sure you want to delete this task?")) {
                                  deleteTask(user.id);
                                }
                              }}
                              title="Delete"
                            >
                              Del
                            </button>
                          )}

                          {allowEdit && (
                          <button
                            className="action-btn"
                            onClick={() => openEditModal(user, index)}
                            title="Edit"
                          >
                            ✏️
                          </button>
                          )}

                          {allowEdit && (
                          <button
                            className="action-btn"
                            onClick={() => {
                              if (window.confirm("Are you sure you want send the emails?")) {
                                sendConfirm(user.customer_id, user.id);
                              }
                            }}
                            title="Send Email"
                          >
                            📩
                          </button>
                          )}
                          {user.mail_status == 1 && <span className="check-mark">✅</span>}
                          
                          {user.assiger_branch == 4 && (
                            <button
                              className="action-btn otp-btn"
                              onClick={() => {
                                if (window.confirm("Are you sure you want to resend OTP to customer?")) {
                                  resendOtp(user.id);
                                }
                              }}
                              title="Resend OTP"
                            >
                              🔑
                            </button>
                          )}

                          <button
                            className="action-btn"
                            onClick={() =>
                              openSeatModal(user.id, user.jc_seat_submitted)
                            }
                            title="JC Seat Submitted"
                          >
                            🪑
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {showSeatModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  JC Seat Submitted {seatJcId ? `(JC-${seatJcId})` : ""}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeSeatModal}
                ></button>
              </div>
              <form onSubmit={handleSeatSubmit}>
                <div className="modal-body">
                  <label className="form-label fw-semibold">
                    JC seat submitted?
                  </label>
                  <select
                    className="form-select"
                    value={seatValue}
                    onChange={(e) => setSeatValue(e.target.value)}
                    required
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeSeatModal}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={seatLoading}
                  >
                    {seatLoading ? "Saving..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Invoice Modal */}
      <InvoiceModal 
        show={showInvoiceModal} 
        onClose={closeInvoiceModal} 
        taskId={invoiceTaskId} 
      />

      <style jsx>{`
        .branch-chip-bar {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 8px;
          padding: 10px 12px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
        }
        .branch-chip-label {
          font-size: 12px;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin-right: 4px;
        }
        .branch-chip {
          border: 1px solid #cbd5e1;
          background: #fff;
          color: #334155;
          border-radius: 999px;
          padding: 6px 14px;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.2;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        .branch-chip:hover {
          border-color: #0d6efd;
          color: #0d6efd;
          background: #eff6ff;
        }
        .branch-chip.active {
          background: #0d6efd;
          border-color: #0d6efd;
          color: #fff;
          box-shadow: 0 2px 8px rgba(13, 110, 253, 0.25);
        }
        .branch-chip.chip-k1.active {
          background: #dc2626;
          border-color: #dc2626;
          box-shadow: 0 2px 8px rgba(220, 38, 38, 0.25);
        }
        .branch-chip.chip-k1:hover:not(.active) {
          border-color: #dc2626;
          color: #dc2626;
          background: #fef2f2;
        }
        .branch-chip.chip-k2.active {
          background: #16a34a;
          border-color: #16a34a;
          box-shadow: 0 2px 8px rgba(22, 163, 74, 0.25);
        }
        .branch-chip.chip-k2:hover:not(.active) {
          border-color: #16a34a;
          color: #16a34a;
          background: #f0fdf4;
        }
        .branch-chip.chip-ojc.active {
          background: #7c3aed;
          border-color: #7c3aed;
          box-shadow: 0 2px 8px rgba(124, 58, 237, 0.25);
        }
        .branch-chip.chip-ojc:hover:not(.active) {
          border-color: #7c3aed;
          color: #7c3aed;
          background: #f5f3ff;
        }

        /* Table styles */
        .table {
          font-size: 0.82rem;
        }

        .table th {
          font-size: 0.85rem;
          white-space: nowrap;
        }

        .table td {
          padding: 6px 8px !important;
          vertical-align: middle;
        }

        /* Created date styles */
        .created-date {
          width: 85px;
          padding: 2px 4px !important;
        }

        .date-line {
          font-size: 0.68rem;
          font-weight: 500;
          color: #2c3e50;
          line-height: 1;
          white-space: nowrap;
        }

        .time-line {
          font-size: 0.68rem;
          color: #6c757d;
          line-height: 1;
          margin-top: 2px;
        }

        /* Time column styles */
        .time-status-column {
          min-width: 100px;
          padding: 6px !important;
        }

        .time-status-wrapper {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .time-status-item {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 3px 6px;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 500;
          white-space: nowrap;
        }

        .time-status-item i {
          font-size: 0.75rem;
        }

        .start-time {
          background-color: rgba(40, 167, 69, 0.15);
          border: 1px solid rgba(40, 167, 69, 0.3);
          color: #198754;
        }

        .end-time {
          background-color: rgba(220, 53, 69, 0.15);
          border: 1px solid rgba(220, 53, 69, 0.3);
          color: #dc3545;
        }

        .pending {
          background-color: rgba(108, 117, 125, 0.15);
          border: 1px solid rgba(108, 117, 125, 0.3);
          color: #6c757d;
        }

        .small {
          font-size: 0.875rem;
          font-weight: 500;
        }

        /* Action Column Styles */
        .action-column {
          padding: 4px 6px !important;
        }

        .action-row-1 {
          margin-bottom: 4px;
        }

        .status-group {
          display: flex;
          gap: 3px;
          align-items: center;
          margin-bottom: 3px;
        }

        .status-group select {
          font-size: 0.72rem;
          padding: 1px 4px;
          height: 22px;
          width: 85px;
          min-width: 85px;
          border-color: #dee2e6;
          border-radius: 3px;
        }

        .save-btn {
          font-size: 1rem;
          padding: 0;
          width: 22px;
          height: 22px;
          background: #28a745;
          border: 1px solid #28a745;
          border-radius: 3px;
          color: white;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          line-height: 1;
        }

        .save-btn:hover {
          background: #218838;
          border-color: #1e7e34;
        }

        .status-group {
          display: flex;
          flex-wrap: nowrap;
          gap: 3px;
        }

        .action-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 3px;
          align-items: center;
        }

        .action-btn {
          font-size: 0.7rem;
          padding: 2px 4px;
          border: 1px solid #dee2e6;
          border-radius: 3px;
          background: white;
          color: #495057;
          min-width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .action-btn:hover {
          background: #f8f9fa;
        }

        .invoice-btn {
          background: #28a745;
          color: white;
          border-color: #28a745;
        }

        .invoice-btn:hover {
          background: #218838;
        }

        .otp-btn {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }

        .otp-btn:hover {
          background: #0056b3;
        }

        .check-mark {
          font-size: 0.7rem;
          margin-left: 2px;
        }

        .custom_select {
          max-width: 110px;
        }
      `}</style>
    </>
  );
}
